export interface VisibilityHandlers {
  onHide: () => void;
  onShow: () => void;
}

export class Visibility {
  private handlers: VisibilityHandlers;
  private attached = false;
  private listener: () => void;

  constructor(handlers: VisibilityHandlers) {
    this.handlers = handlers;
    this.listener = (): void => {
      if (document.hidden) this.handlers.onHide();
      else this.handlers.onShow();
    };
  }

  attach(): void {
    if (this.attached) return;
    document.addEventListener("visibilitychange", this.listener);
    this.attached = true;
  }

  detach(): void {
    if (!this.attached) return;
    document.removeEventListener("visibilitychange", this.listener);
    this.attached = false;
  }
}
